import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserSetting from './user-setting.reducer';
import * as fromShared from '../../shared';

export const selectUserSettingState =
    createFeatureSelector<fromUserSetting.State>(
        fromUserSetting.userSettingsFeatureKey
    );

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromUserSetting.adapter.getSelectors(selectUserSettingState);
export const getCategories = createSelector(selectAll, settings =>
    fromShared.uniqBy(
        settings.map(x => ({
            CatID: x.CatID,
            Description: x.CatDescription
        })),
        x => x.CatID
    )
);

export const getSetting = (settingType: string) =>
    createSelector(selectAll, settings =>
        settings.find(x => x.EmpSettingType === settingType)
    );

//define this in terms of getSetting, just return EmpSettingValue instead of the whole object
export const getSettingValue = (settingType: string) =>
    createSelector(
        selectAll,
        settings =>
            settings.find(x => x.EmpSettingType === settingType)
                ?.EmpSettingValue as string
    );

export const getSettingBooleanValue = (settingType: string) =>
    createSelector(selectAll, settings => {
        const value = settings.find(x => x.EmpSettingType === settingType);
        return value
            ? value.EmpSettingValue === '1' ||
                  value.EmpSettingValue === 1 ||
                  value.EmpSettingValue === 'true' ||
                  value.EmpSettingValue === true
            : false;
    });
